import Joi from 'joi';

/**
 * Schema for new outbox record validation.
 */
export const createOutboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
